import pl from "@locales/sales_purchases/pl.json";
import en from "@locales/sales_purchases/en.json";

export default { pl, en };
